
import * as angular from "angular";
import * as moment from "moment";

// Scrolling through report fires a lot of 'scroll' events.
// This has an effect on browser performance. This service, used by the reportDisplayer directive,
// prevents these events being called repeatedly by introducing a 'pause' till the next time the scroll event is called.
// This is called a 'debouncer'.
export class Debounce {

    static $inject = ["$q", "$timeout"];

    constructor(
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService) {
    }

    // Create a deferred object that will be resolved when we need to actually call the func
    debounce(func: Function, wait: number, immediate: boolean) {
        var deferred = this.$q.defer();
        var timeout: angular.IPromise<void>;
        var self = this;
        //var lastCallTime = moment();

        // CJE Remarks... this is REALLY slow
        console.warn("Check real-life performance of this debounce method.");

        return function () {
            const callNow = immediate && !timeout;
            const context = self, args = arguments;

            const later = () => {
                timeout = null;

                if (!immediate) {
                    deferred.resolve(func.apply(self, args));
                    deferred = self.$q.defer();
                }
            };

            if (timeout) {
                self.$timeout.cancel(timeout);
            }

            timeout = self.$timeout(later, wait);

            if (callNow) {
                deferred.resolve(func.apply(context, args));
                deferred = self.$q.defer();
            }

            return deferred.promise;
        };
    }
}
